import { render, staticRenderFns } from "./HealthInfoChart.vue?vue&type=template&id=12db1e3d&scoped=true"
import script from "./HealthInfoChart.vue?vue&type=script&lang=js"
export * from "./HealthInfoChart.vue?vue&type=script&lang=js"
import style0 from "./HealthInfoChart.vue?vue&type=style&index=0&id=12db1e3d&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db1e3d",
  null
  
)

export default component.exports